import React from "react";
import { completoAdvantages } from "../../data/sections";
import { extraResources } from "../../data/bonuses";
import { SectionHeading } from "../ui/SectionHeading";
import { LinkButton } from "../ui/Buttons";
export function CompleteAdvantages() {
  return <section id="completo" aria-labelledby="completo-title" className="scroll-mt-20 bg-crema/60 py-20 md:py-28" data-id="element-26" data-mp="16rp5zs9ftrm4">
      <div className="mx-auto max-w-6xl px-4 md:px-6" data-id="element-27" data-mp="1flvhcsftp766">
        <SectionHeading id="completo-title" eyebrow="Exclusivo del plan Completo" title="¿Por qué elegir el Completo?" intro="Los dos recursos adicionales forman parte del precio del Completo. Sirven para aplicar lo que estudiaste y para consultar cuando lo necesitás." data-id="element-28" data-mp="1flbyn9icmer3" />
        <div className="mt-14 grid gap-8 md:grid-cols-2" data-id="element-29" data-mp="1uh1nrgitz801">
          {extraResources.map(r => <article key={r.id} className="grid gap-6 rounded-[28px] bg-papel p-5 sm:grid-cols-[180px_1fr] md:p-6" data-id="element-30" data-mp="3rdhbucha228n">
              <img src={r.image} alt={`Mockup del ebook ${r.title}`} loading="lazy" className="aspect-[3/4] w-full max-w-[200px] rounded-2xl object-cover sm:max-w-none" data-id="element-31" data-mp="268cluopcgzog" />
              <div className="flex flex-col" data-id="element-32" data-mp="1wjb87569uudn">
                <h3 className="font-serif text-2xl font-medium leading-snug text-pizarra-deep" data-id="element-33" data-mp="1rjgi33ubm8tn">{r.title}</h3>
                <p className="mt-1 text-sm text-pizarra-soft" data-id="element-34" data-mp="2p6ypaa8c32vj">{r.subtitle}</p>
                <p className="mt-4 leading-relaxed text-pizarra" data-id="element-35" data-mp="2p4unbxtzwdxw">{r.benefit}</p>
                <p className="mt-auto pt-4 text-sm leading-relaxed text-pizarra-deep" data-id="element-36" data-mp="2k8x67pawr3k2">
                  <span className="font-semibold" data-id="element-37" data-mp="2f7g6vy82np5l">Ejemplo: </span>
                  {r.example}
                </p>
              </div>
            </article>)}
        </div>
        <div className="mt-16 grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:items-center" data-id="element-38" data-mp="13ux90m3g5s0i">
          <blockquote className="font-serif text-3xl font-medium leading-tight text-pizarra-deep md:text-4xl" data-id="element-39" data-mp="zrr35fk8y2uk">
            “Una colección para aprender, reforzar y consultar.”
          </blockquote>
          <dl className="grid gap-x-8 gap-y-6 sm:grid-cols-2" data-id="element-40" data-mp="1692cyjlki1zj">
            {completoAdvantages.map(a => <div key={a.title} className="border-l-2 border-terracota pl-4" data-id="element-41" data-mp="ra8dsykxvis0">
                <dt className="font-semibold text-pizarra-deep" data-id="element-42" data-mp="w9tp88hapjlm">{a.title}</dt>
                <dd className="mt-1 leading-relaxed text-pizarra" data-id="element-43" data-mp="iiycum7l8kda">{a.text}</dd>
              </div>)}
          </dl>
        </div>
        <div className="mt-12 text-center" data-id="element-44" data-mp="naq5r3e7v26l">
          <LinkButton href="#planes" withArrow data-id="element-45" data-mp="nbridcavrwqf">
            Quiero el Completo
          </LinkButton>
        </div>
      </div>
    </section>;
}